/**
 * Single post
 */

import $ from 'jquery';

/**
 * Enable enhanced hover effect on making photos when using a non-touch device
 */

function initEnhanceHovers() {
  var hoverClass = 'is-hover';
  var $target = $('.SinglePost .FlexEmbed');
  var preventMouseover = false;

  function forTouchstart() {
    preventMouseover = true;
  }

  function forMouseover() {
    if (preventMouseover === false) {
      $(this)
        .parent()
        .addClass(hoverClass);
    } else {
      preventMouseover = false;
    }
  }

  function forMouseout() {
    $(this)
      .parent()
      .removeClass(hoverClass);
  }

  $target.on({
    touchstart: forTouchstart,
    mouseover: forMouseover,
    mouseout: forMouseout
  });
}

/**
 * Initialise module
 */

function init() {
  // return early if no SinglePost module present
  if (!$('.SinglePost').length) {
    return;
  }

  initEnhanceHovers();
}

$(document).ready(init);
